import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import styles from './Activities.css';

class Activities extends React.Component {
  render() {
    const { purchaseOrderDetail } = this.props;
    return (
      <table className="table table-bordered">
        <tbody>
          {purchaseOrderDetail.activities.map(act => this._activity(act))}
        </tbody>
      </table>
    );
  }

  _activity = activity => {
    const { purchaseOrderDetail } = this.props;
    const key = activity.key.substr(activity.key.indexOf('.') + 1);
    return (
      <tr key={key}>
        <td className={styles.activity}>
          At {moment(activity.created_at).format('MM/DD/YYYY HH:mm')} #
          {purchaseOrderDetail.order_no} is {key}
          {this._symbol(activity)}
        </td>
      </tr>
    );
  };

  _symbol = activity => {
    if (
      activity.key === 'purchase_order.created' ||
      activity.key === 'ingredient_purchase_order.created'
    ) {
      return (
        <span
          className={`glyphicon glyphicon-plus pull-right btn btn-warning ${styles.symbol}`}
        />
      );
    }
    if (
      activity.key === 'purchase_order.fulfilled' ||
      activity.key === 'ingredient_purchase_order.fulfilled'
    ) {
      return (
        <span
          className={`glyphicon glyphicon-ok pull-right btn btn-success ${styles.symbol}`}
        />
      );
    }
    if (
      activity.key === 'purchase_order.cancelled' ||
      activity.key === 'ingredient_purchase_order.cancelled'
    ) {
      return (
        <span
          className={`glyphicon glyphicon-minus pull-right btn btn-danger ${styles.symbol}`}
        />
      );
    }
    if (
      activity.key === 'purchase_order.updated' ||
      activity.key === 'ingredient_purchase_order.updated'
    ) {
      return (
        <span
          className={`glyphicon glyphicon-plus pull-right btn btn-warning ${styles.symbol}`}
        />
      );
    }
    return <span />;
  };
}

Activities.propTypes = {
  purchaseOrderDetail: PropTypes.object,
};
export default Activities;
